import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PrimaryCheckbox from '@/components/common/PrimaryCheckbox';
import { TextSelectFieldValueType } from '@/propTypes';
import TextSelectFieldItemImage from './TextSelectFieldItemImage';

export default function TextSelectFieldItem({
  id,
  item,
  multiple,
  value,
  primaryValue,
  setPrimaryValue,
  usePrimary,
}) {
  const { value: itemValue, text } = item;

  const isChecked = !!(multiple ? value : [value])?.find(
    (el) => el?.value === itemValue,
  );

  return (
    <div className={classNames('relative flex w-full items-center')}>
      <TextSelectFieldItemImage id={id} {...item} />
      <span
        className={classNames('type-body1', {
          'mr-12': !usePrimary,
          'mr-17': usePrimary,
        })}
      >
        {text}
      </span>
      {usePrimary && isChecked && (
        <div className="absolute right-10 top-0.5">
          <PrimaryCheckbox
            checkboxProps={{
              id: `${id}-${itemValue}-option-primary-checkbox`,
              name: `${id}-${itemValue}-option-primary-checkbox`,
            }}
            primary={itemValue === primaryValue}
            onChange={(isPrimary) =>
              setPrimaryValue(isPrimary ? itemValue : null)
            }
          />
        </div>
      )}
      {multiple ? (
        <Checkbox
          id={`${id}-${itemValue}-option-checkbox`}
          className="absolute -right-2"
          checked={isChecked}
          value={itemValue}
        />
      ) : (
        <Radio
          id={`${id}-${itemValue}-option-radio`}
          className="absolute -right-2"
          checked={isChecked}
          value={itemValue}
        />
      )}
    </div>
  );
}

TextSelectFieldItem.propTypes = {
  id: PropTypes.string.isRequired,
  item: TextSelectFieldValueType.isRequired,
  multiple: PropTypes.bool,
  value: PropTypes.oneOfType([
    TextSelectFieldValueType,
    PropTypes.arrayOf(TextSelectFieldValueType),
  ]),
  primaryValue: PropTypes.string,
  setPrimaryValue: PropTypes.func,
  usePrimary: PropTypes.bool,
};

TextSelectFieldItem.defaultProps = {
  multiple: false,
  primaryValue: '',
  setPrimaryValue: () => {},
  value: null,
  usePrimary: false,
};
